import React, { PropsWithChildren, useState } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';
import { Button, Col, ReviewsCard, Row, Section, Title } from '../../importCL';
import { transformHTMLParserLinks } from '../../utils/rewriteLink/rewriteLink';
import { ISectionProps } from '../../component-library/molecules/Section/Section';
import { useWidthContext } from '../../providers/Width';

import './ReviewsExpanding.css';

interface ITestimonials {
  author?: string;
  headline?: string;
  quote?: string;
}
interface IReviewsExpandingProps extends MappedComponentProperties {
  bgColor: ISectionProps['bgColor'];
  headline?: string;
  subheadline?: string;
  contentFragmentPath?: string;
  ctaForMore?: string;
  testimonials?: ITestimonials[];
}

export const ReviewsExpandingEditConfig = {
    emptyLabel: 'Reviews Expanding',
    isEmpty: (props: PropsWithChildren<IReviewsExpandingProps>) => {
        return !props || !props.headline;
    },
};

const ReviewsExpanding = (
    props: PropsWithChildren<IReviewsExpandingProps>,
): JSX.Element => {
    const testimonials = props.testimonials || [];
    const [reviewsChunks, setReviewsChunks] = useState<ITestimonials[]>(
        testimonials.slice(0, 25),
    );

    const isLightColor = props.bgColor === 'white' || props.bgColor === 'light-gray';
    const textColor = isLightColor ? 'text-grey-tundora' : 'text-white';
    const { width } = useWidthContext();

    const handleClick = () => {
        setReviewsChunks(testimonials?.slice(0, reviewsChunks.length + 25));
    };

    const getCard = (el: ITestimonials) => {
        return (
            <ReviewsCard
                className='mb-8'
                cardVariant='testimonial'
                reviewContent={{
                    headLineText: transformHTMLParserLinks(el.headline),
                    bodyText: transformHTMLParserLinks(el.quote),
                    bottomLineText: transformHTMLParserLinks(el.author),
                }}
            />
        );
    };

    const getCardsFiltered = (type: string): ITestimonials[] => {
        const odd = reviewsChunks.filter((_, i) => (i + 1) % 2 !== 0);
        const even = reviewsChunks.filter((_, i) => (i + 1) % 2 === 0);
        const desktopArray = type === 'odd' ? odd : even;
        const mobileArray = reviewsChunks;
        return width < 768 ? mobileArray : desktopArray;
    };

    return (
        <Section className={`ReviewsExpanding ${!isLightColor ? 'darkMode' : ''}`}  bgColor={props.bgColor} horizontalTitle
        title={props.headline && transformHTMLParserLinks(props.headline)} titleClass={`ReviewsExpanding__title mb-8 justify-left ${textColor}`} spanTitle={props.subheadline && transformHTMLParserLinks(props.subheadline)}>
            <Row>
                <Col xs={6}>
                    {getCardsFiltered('odd').map(el => {
                        return getCard(el);
                    })}
                </Col>
                {width >= 768 &&
          <Col xs={6}>
              {getCardsFiltered('even').map(el => {
                  return getCard(el);
              })}
          </Col>
                }
                <Col className='ReviewsExpanding__viewMoreBtn md:mt-12 mt-8 flex justify-center'>
                    {reviewsChunks.length < props.testimonials?.length && (
                        <Button
                            variant='link'
                            icon='arrowDown'
                            size='medium'
                            onClick={handleClick}
                        >
              View More
                        </Button>
                    )}
                </Col>
            </Row>
        </Section>
    );
};

export default ReviewsExpanding;
